// The city's buildings, drawn. Matt: "the player board itself doesn't look
// great, it's too flat, these things don't read as buildings... it should
// look like a little worker placement spot, make the spots obvious."
//
// Same idea as the Hall's card emblems: constant line art in a 24x24 box,
// stroked in currentColor. No files, nothing to load, and it scales with the
// map. The phone never gets three.js - that is the table's job.

export const BUILDING_ART = {
  field: '<path d="M2.5 20h19M2.5 16h19"/><path d="M12 13V7"/><path d="M12 7c-2.6 0-4-1.4-4-4 2.6 0 4 1.4 4 4Zm0 0c2.6 0 4-1.4 4-4-2.6 0-4 1.4-4 4Z"/>',
  workshop: '<path d="M4 21h16"/><path d="M7 21v-5h10v5"/><path d="M6 16 8 8h8l2 8"/><path d="M12 8V4"/><path d="M9.5 4h5"/>',
  market: '<path d="M3 9h18l-2.2-5H5.2Z"/><path d="M5 9v12h14V9"/><path d="M9 21v-6h6v6"/>',
  granary: '<path d="M7 21V9.5a5 5 0 0 1 10 0V21Z"/><path d="M7 13.5h10M7 17h10"/><path d="M4.5 21h15"/>',
  warehouse: '<rect x="3" y="12.5" width="8" height="8" rx="1"/><rect x="13" y="12.5" width="8" height="8" rx="1"/><rect x="8" y="3.5" width="8" height="8" rx="1"/>',
  mill: '<path d="M12 21v-8"/><path d="M8 21h8"/><path d="m12 13 6.5-3.5M12 13 5.5 16.5M12 13 8.5 6.5M12 13l7 3.5"/><circle cx="12" cy="13" r="1.6"/>',
  house: '<path d="M3.5 11 12 4l8.5 7"/><path d="M5.5 9.5V20h13V9.5"/><path d="M10 20v-5h4v5"/>',
  // The Scholars' machines (2026-10-15).
  kiln: '<path d="M4 20h16"/><path d="M6 20v-7a6 6 0 0 1 12 0v7"/><path d="M10 20v-3.5a2 2 0 0 1 4 0V20"/><path d="M12 9c1.2 1.1 1.5 2 .9 3-.4.7-1.4.7-1.8 0-.5-.9-.1-1.8.9-3Z"/>',
  still: '<path d="M7 21h10"/><path d="M8.5 21v-3a3.5 3.5 0 0 1 7 0v3"/><path d="M12 14.5V8"/><path d="M12 8c0-2.5 2-4 5-4h2v4"/><path d="M19 8v3"/>',
  crucible: '<path d="M5 8h14l-2 10a2 2 0 0 1-2 1.6H9A2 2 0 0 1 7 18Z"/><path d="M9 4.5 10 8M15 4.5 14 8"/><path d="M8.5 12.5h7"/>',
};

export const artForBuilding = (type) => BUILDING_ART[type] || BUILDING_ART.workshop;

// What a worker put here brings back today, as a resource and a number, so
// the board can say what a placement achieves before you make it. Passive
// buildings (granary, warehouse, mill) have no daily yield: they change the
// rules instead, which the building's own line says.
export const yieldOf = (type, { field, workshop, market }) => {
  if (type === 'field') return { kind: 'food', n: field };
  if (type === 'workshop') return { kind: 'goods', n: workshop };
  if (type === 'market') return { kind: 'coin', n: market };
  return null;
};

// The things the Stewards can do away from the city, for the buttons below
// the map. Matt: "I don't think we have room for the buy grain, haggle and
// caravan on the map... return those to below the map, give those an icon."
export const ACTION_ART = {
  caravan: '<path d="M2.5 17h15"/><circle cx="6.5" cy="19.5" r="2"/><circle cx="15" cy="19.5" r="2"/><path d="M3 17V8h12l4 4v5"/><path d="M3 12h12"/>',
  'buy-grain': '<path d="M6 9h12l-1.4 11H7.4Z"/><path d="M8.5 9V6.5a3.5 3.5 0 0 1 7 0V9"/><path d="M9.5 13.5h5"/>',
  hire: '<circle cx="9" cy="7" r="3"/><path d="M3.5 20a5.5 5.5 0 0 1 11 0"/><path d="M15 9h5.5"/><path d="M15 12.5h5.5"/><path d="M15 16h5.5"/>',
  haggle: '<ellipse cx="12" cy="6.5" rx="6.5" ry="2.6"/><path d="M5.5 6.5v4c0 1.4 2.9 2.6 6.5 2.6s6.5-1.2 6.5-2.6v-4"/><path d="M5.5 12v4c0 1.4 2.9 2.6 6.5 2.6s6.5-1.2 6.5-2.6v-4"/>',
  annex: '<path d="M12 2.5 20.5 7v10L12 21.5 3.5 17V7Z"/><path d="M12 8.5v7M8.5 12h7"/>',
  'build-monument': '<path d="M5 21h14"/><path d="M8 21V9l4-5 4 5v12"/><path d="M8 13h8M8 17h8"/>',
  repair: '<path d="m4 20 8-8"/><path d="M13.5 10.5 19 5"/><path d="M15.5 8.5a3.5 3.5 0 0 0 4.8-4.4l-2.2 2.2-2.4-2.4 2.2-2.2A3.5 3.5 0 0 0 13.5 6.5Z"/>',
};

export const artForAction = (id) => ACTION_ART[id] || ACTION_ART.haggle;
